import { render } from "./PlatformSwitcher.vue?vue&type=template&id=642f16e3&ts=true"
import script from "./PlatformSwitcher.vue?vue&type=script&lang=ts"
export * from "./PlatformSwitcher.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__